var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavicon04(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2671 20.998C10.4426 21.3021 10.6951 21.5545 10.9991 21.73C11.3032 21.9056 11.648 21.998 11.9991 21.998C12.3501 21.998 12.695 21.9056 12.999 21.73C13.3031 21.5545 13.5555 21.3021 13.7311 20.998",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26173 15.3245C3.13111 15.4677 3.04491 15.6457 3.01361 15.837C2.98232 16.0283 3.00728 16.2245 3.08546 16.4018C3.16364 16.5792 3.29167 16.73 3.45397 16.8359C3.61628 16.9418 3.80586 16.9982 3.99967 16.9984H19.9982C20.192 16.9985 20.3816 16.9422 20.544 16.8365C20.7064 16.7308 20.8346 16.5802 20.913 16.4029C20.9914 16.2257 21.0166 16.0296 20.9855 15.8383C20.9545 15.647 20.8685 15.4689 20.7381 15.3255C19.4083 13.9547 17.9984 12.4978 17.9984 7.99921C17.9984 6.40805 17.3663 4.88207 16.2412 3.75695C15.1161 2.63184 13.5901 1.99976 11.9989 1.99976C10.4078 1.99976 8.8818 2.63184 7.75668 3.75695C6.63157 4.88207 5.99948 6.40805 5.99948 7.99921C5.99948 12.4978 4.58861 13.9547 3.26173 15.3245Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon04);
export default __webpack_public_path__ + "static/media/navicon04.1dd4ffb5f361184537384ee510f89ef6.svg";
export { ForwardRef as ReactComponent };